module.exports = __webpack_public_path__ + "assets/img/banner.cb66699f.jpg";